import { render, staticRenderFns } from "./skew-button.vue?vue&type=template&id=3ac18738&"
import script from "./skew-button.vue?vue&type=script&lang=js&"
export * from "./skew-button.vue?vue&type=script&lang=js&"
import style0 from "./skew-button.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports